import {Divider, Space} from 'antd';
import React, {memo, useCallback} from 'react';
import {useQueryClient} from 'react-query';

import {createDeleteMany} from '@/utils/createDeleteMany';


export const createEntityBulkActions = (service, name, translation) => {
  const EntityDeleteManyButton = createDeleteMany(service.deleteMany, name, translation);
  
  // eslint-disable-next-line react/prop-types
  const EntitySelectionAction = ({name, selectedRowKeys}) => {
    const queryClient = useQueryClient();
    
    const handleChange = useCallback(() => {
      queryClient.invalidateQueries(name);
    }, [name, queryClient]);
    
    return (
      <Space size={0}>
        <Divider size={'small'} type="vertical"/>
        <EntityDeleteManyButton items={selectedRowKeys} onDelete={handleChange}/>
      </Space>
    );
  };
  
  return memo(EntitySelectionAction);
};
